export const isPhoneIdentifier = (value) => {
  const trimmed = value.trim();
  if (!trimmed) {
    return false;
  }

  if (/[a-zA-Z_]/.test(trimmed)) {
    return false;
  }

  const digits = trimmed.replace(/\D/g, '');
  if (!digits) {
    return false;
  }

  return (
    /^\+?254\d{9}$/.test(trimmed.replace(/\s/g, ''))
    || /^0\d{9}$/.test(digits)
    || /^254\d{9}$/.test(digits)
    || /^\d{9}$/.test(digits)
  );
};
